import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-4">
      <div className="relative w-full max-w-lg mb-8">
        <img
          src="https://i.imgflip.com/9l52tr.jpg"
          alt="Racing meme"
          className="w-full h-auto rounded-lg shadow-xl"
        />
      </div>
      <p className="text-lg text-gray-600 mb-8 dark:text-gray-400">
        Looks like you've spun out into a 404. Let's get you back on track!
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors duration-300 shadow-lg hover:shadow-xl dark:bg-blue-600 dark:hover:bg-blue-700"
      >
        Back to Pit Lane
      </Link>
    </div>
  );
};

export default NotFound;
